var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-input", class: _vm.classes },
    [
      _c(
        "label",
        {
          staticClass: "text-input__label",
          class: { "u-sr-only": _vm.hideLabel },
          attrs: { for: _vm.inputId }
        },
        [
          _vm._v(_vm._s(_vm.label)),
          _vm.required
            ? _c("div", { staticClass: "text-input__label-note" }, [
                _vm._v("(required)")
              ])
            : _vm._e()
        ]
      ),
      _vm.isTextArea
        ? _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.currentValue,
                expression: "currentValue"
              }
            ],
            staticClass: "text-input__input",
            attrs: {
              type: _vm.inputType,
              id: _vm.inputId,
              name: _vm.name,
              disabled: _vm.disabled,
              required: _vm.required,
              placeholder: _vm.placeholder,
              pattern: _vm.pattern,
              rows: _vm.rows
            },
            domProps: { value: _vm.currentValue },
            on: {
              focusout: _vm.validate,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.currentValue = $event.target.value
              }
            }
          })
        : _vm.inputType === "checkbox"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.currentValue,
                expression: "currentValue"
              }
            ],
            staticClass: "text-input__input",
            attrs: {
              id: _vm.inputId,
              name: _vm.name,
              disabled: _vm.disabled,
              required: _vm.required,
              placeholder: _vm.placeholder,
              pattern: _vm.pattern,
              type: "checkbox"
            },
            domProps: {
              checked: Array.isArray(_vm.currentValue)
                ? _vm._i(_vm.currentValue, null) > -1
                : _vm.currentValue
            },
            on: {
              focusout: _vm.validate,
              change: function($event) {
                var $$a = _vm.currentValue,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.currentValue = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.currentValue = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.currentValue = $$c
                }
              }
            }
          })
        : _vm.inputType === "radio"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.currentValue,
                expression: "currentValue"
              }
            ],
            staticClass: "text-input__input",
            attrs: {
              id: _vm.inputId,
              name: _vm.name,
              disabled: _vm.disabled,
              required: _vm.required,
              placeholder: _vm.placeholder,
              pattern: _vm.pattern,
              type: "radio"
            },
            domProps: { checked: _vm._q(_vm.currentValue, null) },
            on: {
              focusout: _vm.validate,
              change: function($event) {
                _vm.currentValue = null
              }
            }
          })
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.currentValue,
                expression: "currentValue"
              }
            ],
            staticClass: "text-input__input",
            attrs: {
              id: _vm.inputId,
              name: _vm.name,
              disabled: _vm.disabled,
              required: _vm.required,
              placeholder: _vm.placeholder,
              pattern: _vm.pattern,
              type: _vm.inputType
            },
            domProps: { value: _vm.currentValue },
            on: {
              focusout: _vm.validate,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.currentValue = $event.target.value
              }
            }
          }),
      _c(
        _vm.iconIsSubmitButton ? "base-button" : "div",
        {
          tag: "div",
          staticClass: "text-input__icon",
          class: _vm.iconIsSubmitButton ? "button--icon" : null,
          style: "line-height: " + (_vm.height || _vm.size) + ";",
          attrs: {
            type: _vm.iconIsSubmitButton ? "submit" : null,
            width: _vm.width || _vm.size,
            height: _vm.height || _vm.size
          }
        },
        [
          _vm.icon
            ? _c("icon", {
                class: _vm.iconIsSubmitButton ? "button__icon" : null,
                attrs: {
                  name: _vm.icon,
                  width: _vm.width || _vm.size,
                  height: _vm.height || _vm.size
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.valueIsErroneous
        ? _c("div", { staticClass: "text-input__error-notice error-message" }, [
            _vm._v(_vm._s(_vm.errorText))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }